export default "__VITE_ASSET__spvpcjVr__"